module.exports = __webpack_public_path__ + "img/razorpay_banner.12d84617.svg";